import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import styled from 'styled-components';
import { useParallax } from 'react-scroll-parallax';
import Grid from '@nubank/nuds-web/components/Grid/Grid';

const StyledLink = styled(Link)`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const StyledTitle = styled(Typography)`
  font-size: 1.8rem;

  span {
    /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
    background-image: linear-gradient(137.07deg, #9F2DEB 42.83%, #6200A3 86.85%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  @media (width >= 1150px) {
    font-size: 2.2rem;
  }
`;

function Benefits() {
  const { ref } = useParallax({
    opacity: [0, 1],
    easing: [0, 0.9, 1, 1.4],
  });

  return (

    <Box
      tag="section"
      height="100%"
      width="100%"
      marginTop={{ xs: '8x', lg: '40px' }}
      marginBottom={{ xs: '32px', lg: '100px' }}
      paddingHorizontal={{ xs: '32px', lg: '56px' }}
    >
      <Grid
        paddingLeft={{ xs: '0', lg: '0x' }}
        paddingRight={{ xs: '0', lg: '0' }}
      >

        {/* CONTENT BOX */}

        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '2 / span 4', lg: '2 / span 10' }}
          gridRow="1"
        >

          <Box
            display="flex"
            flexDirection={{ xs: 'column' }}
            justifyContent="center"
            marginBottom={{ xs: '40px', lg: '0' }}
            paddingHorizontal={{ xs: '0', lg: '56px' }}
            maxWidth={{ xs: '100%', lg: '1215px' }}
            margin={{ xs: '0', lg: '0 auto' }}
          >

            <Box
              background="#F8F8FA"
              minHeight={{ xs: '300px', lg: '170px' }}
              display="flex"
              alignItems="center"
              flexDirection={{ xs: 'column', lg: 'row' }}
              paddingHorizontal={{ xs: '16px', lg: '0' }}
              justifyContent={{ xs: 'center', lg: 'center' }}
              borderRadius="12px"
            >
              <Box
                paddingLeft={{ xs: '0', lg: '70px' }}
              >
                <StyledTitle
                  variant="heading3"
                  textAlign="center"
                  whiteSpace={{ xs: 'pre-line', lg: 'normal' }}
                  marginBottom="35px"
                  ref={ref}
                >
                  Además,
                  <span> Nu</span>
                  {' te da \n más '}
                  <span>{'beneficios y \n promociones'}</span>
                </StyledTitle>

                <StyledLink
                  href="/beneficios"
                  iconProps={{ name: 'arrow-up-right' }}
                >
                  Conoce más
                </StyledLink>

              </Box>

            </Box>

          </Box>
        </Grid.Child>
      </Grid>
    </Box>
  );
}

export default Benefits;
